import $ from "jquery";
import ko from "knockout";
import register from "flow/knockout/register";
import Component from "flow/Component";

register.registerKnockoutBinding("details", {
    init: function (element, valueAccessor) {
        const $containerElement = $("<div></div>");
        const containerElement = $containerElement[0];
        ko.virtualElements.prepend(element, containerElement);

        const componentObs = valueAccessor();

        let currentComponent = componentObs();

        const handleComponentChange = function (newComponent: Component) {
            currentComponent = newComponent;

            if (
                newComponent === null ||
                newComponent === undefined ||
                newComponent.manifest.detailViewUrl === null ||
                newComponent.manifest.detailViewUrl === undefined
            ) {
                ko.cleanNode(containerElement);
                $containerElement.html("");
                return;
            }

            newComponent.load().done(function () {
                // Abort if component has changed while we were loading
                if (newComponent === currentComponent) {
                    ko.cleanNode(containerElement);
                    $containerElement.html(newComponent.detailHtml());
                    ko.applyBindings(newComponent.viewModel(), containerElement);

                    newComponent.onDetailViewAttached(containerElement);
                }
            });
        };

        componentObs.subscribe(handleComponentChange);

        if (componentObs()) {
            handleComponentChange(componentObs());
        }

        return { controlsDescendantBindings: true };
    }
});
